module.exports = __webpack_public_path__ + "static/media/grigore-ricky-vRkiYoCeN2g-unsplash.34527d37.jpg";